import React from "react";

function ConfirmDialog({ message, onConfirm, onCancel }) {
  return (
    <div className="modal">
      <div className="modal-box">
        <h3 style={{ color: "#d90000" }}>Xác nhận</h3>
        <p>{message}</p>

        <div className="modal-actions">
          <button className="btn danger" onClick={onConfirm}>Đồng ý</button>
          <button className="btn cancel" onClick={onCancel}>Hủy</button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;
